import { FC } from "react";
import { Add } from "@mui/icons-material";
import { Button, styled } from "@mui/material";

const AddButton = styled(Button)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

interface AddCardProps {
  onClick?: () => void;
}

const AddCard: FC<AddCardProps> = ({ onClick }) => (
  <AddButton variant="outlined" onClick={onClick}>
    <Add />
  </AddButton>
);

export default AddCard;
